module.exports = __webpack_public_path__ + "static/clay-logo-hover-b1fe3ffce7652449b4b86ea5fbc2fe9b.png";